import AppRouter from '../AppRouter';

const App = (): JSX.Element => {
    return <AppRouter />;
};

export default App;
